import toast from "react-hot-toast";
import {
  fetchDataFailure,
  fetchDataRequest,
  fetchDataSuccess,
} from "./actions/actions";
import axiosInstance from "./axiosInstance";
import {
  fetchBranchRequest,
  fetchBranchSuccess,
  fetchBranchFailure,
  createBranchRequest,
  createBranchSuccess,
  createBranchFailure,
  updateBranchRequest,
  updateBranchSuccess,
  updateBranchFailure,
  deleteBranchRequest,
  deleteBranchSuccess,
  deleteBranchFailure,
} from "./branches/branchesAction";
import {
  fetchDashboardSummaryRequest,
  fetchDashboardSummarySuccess,
  fetchDashboardSummaryFailure,
} from "./dashboard/dashboardActions";
import {
  fetchProfitLossRequest,
  fetchProfitLossSuccess,
  fetchProfitLossFailure,
} from "./profitloss/profitlossActions";
import {
  createFoodFailure,
  createFoodRequest,
  createFoodSuccess,
  deleteFoodFailure,
  deleteFoodRequest,
  deleteFoodSuccess,
  fetchFoodFailure,
  fetchFoodRequest,
  fetchFoodSuccess,
  updateFoodFailure,
  updateFoodRequest,
  updateFoodSuccess,
  uploadExcelFoodRequest,
  uploadExcelFoodSuccess,
  uploadExcelFoodFailure
} from "./food/foodAction";
import {
  createOrderFailure,
  createOrderRequest,
  createOrderSuccess,
  deleteOrderFailure,
  deleteOrderRequest,
  deleteOrderSuccess,
  fetchOrderFailure,
  fetchOrderRequest,
  fetchOrderSuccess,
  updateOrderFailure,
  updateOrderRequest,
  updateOrderSuccess,
} from "./order/orderAction";
import {
  createRawItemFailure,
  createRawItemRequest,
  createRawItemSuccess,
  deleteRawItemFailure,
  deleteRawItemRequest,
  deleteRawItemSuccess,
  fetchRawItemsFailure,
  fetchRawItemsRequest,
  fetchRawItemsSuccess,
  updateRawItemFailure,
  updateRawItemRequest,
  updateRawItemSuccess,
} from "./rawItems/rawItemActions";
import {
  createTableFailure,
  createTableRequest,
  createTableSuccess,
  deleteTableFailure,
  deleteTableRequest,
  deleteTableSuccess,
  fetchFloorsSuccess,
  fetchTableFailure,
  fetchTableRequest,
  fetchTableSuccess,
  updateTableFailure,
  updateTableRequest,
  updateTableSuccess,
} from "./table/tableActions";
import {
  fetchUserLoginFailure,
  fetchUserLoginRequest,
  fetchUserLoginSuccess,
  updateUserLoginFailure,
  updateUserLoginRequest,
  updateUserLoginSuccess,
} from "./userLogin/userActions";
import {
  createHotelFailure,
  createHotelRequest,
  createHotelSuccess,
  deleteHotelFailure,
  deleteHotelRequest,
  deleteHotelSuccess,
  fetchHotelFailure,
  fetchHotelRequest,
  fetchHotelSuccess,
  updateHotelFailure,
  updateHotelRequest,
  updateHotelSuccess,
} from "./hotel/hotelAction";
import {
  createUserProfileFailure,
  createUserProfileRequest,
  createUserProfileSuccess,
  deleteUserProfileFailure,
  deleteUserProfileRequest,
  deleteUserProfileSuccess,
  fetchUserProfileDataFailure,
  fetchUserProfileDataRequest,
  fetchUserProfileDataSuccess,
  updateUserProfileFailure,
  updateUserProfileRequest,
  updateUserProfileSuccess,
} from "./userProfileData/userProfileDataActions";
import {
  fetchMonthlyReportFailure,
  fetchMonthlyReportRequest,
  fetchMonthlyReportSuccess,
} from "./monthlyReport/monthlyReportAction";
import {
  fetchInvoicesFailure,
  fetchInvoicesRequest,
  fetchInvoicesSuccess,
} from "./Invoices/invoiceActions";
import {
  createStockconsumptionFailure,
  createStockconsumptionRequest,
  createStockconsumptionSuccess,
  deleteStockconsumptionFailure,
  deleteStockconsumptionRequest,
  deleteStockconsumptionSuccess,
  fetchStockconsumptionFailure,
  fetchStockconsumptionRequest,
  fetchStockconsumptionSuccess,
  updateStockconsumptionFailure,
  updateStockconsumptionRequest,
  updateStockconsumptionSuccess,
} from "./stockconsumption/stockConsumptionAction";
import {
  createExpenseFailure,
  createExpenseRequest,
  createExpenseSuccess,
  deleteExpenseFailure,
  deleteExpenseRequest,
  deleteExpenseSuccess,
  fetchExpensesFailure,
  fetchExpensesRequest,
  fetchExpensesSuccess,
  updateExpenseFailure,
  updateExpenseRequest,
  updateExpenseSuccess,
} from "./expenses/expensesAction";
import {
  createSupplierFailure,
  createSupplierRequest,
  createSupplierSuccess,
  deleteSupplierFailure,
  deleteSupplierRequest,
  deleteSupplierSuccess,
  fetchSupplierequest,
  fetchSupplierFailure,
  fetchSupplierSuccess,
  updateSupplierFailure,
  updateSupplierRequest,
  updateSupplierSuccess,
} from "./supplier/supplierAction";
import {
  createWaiterFailure,
  createWaiterRequest,
  createWaiterSuccess,
  deleteWaiterFailure,
  deleteWaiterRequest,
  deleteWaiterSuccess,
  fetchWaitersFailure,
  fetchWaitersRequest,
  fetchWaitersSuccess,
  updateWaiterFailure,
  updateWaiterRequest,
  updateWaiterSuccess,
} from "./Waiters/waitersActions";
import {
  fetchInfoFailure,
  fetchInfoRequest,
  fetchInfoSuccess,
  updateInfoFailure,
  updateInfoRequest,
  updateInfoSuccess,
} from "./restaurantinfo/restaurantinfoAction";
import {
  createTaxFailure,
  createTaxRequest,
  createTaxSuccess,
  fetchTaxFailure,
  fetchTaxRequest,
  fetchTaxSuccess,
  updateTaxFailure,
  updateTaxRequest,
  updateTaxSuccess,
} from "./TaxSetting/taxsettingAction";
import {
  fetchPrinterFailure,
  fetchPrinterRequest,
  fetchPrinterSuccess,
  updatePrinterFailure,
  updatePrinterRequest,
  updatePrinterSuccess,
} from "./Printer/PrinterAction";
import {
  fetchReportFailure,
  fetchReportRequest,
  fetchReportSuccess,
} from "./Report/reportAction";
import { number, string } from "prop-types";
import {
  createCategoryFailure,
  createCategoryRequest,
  createCategorySuccess,
  deleteCategoryFailure,
  deleteCategoryRequest,
  deleteCategorySuccess,
  fetchCategoryFailure,
  fetchCategoryRequest,
  fetchCategorySuccess,
  updateCategoryFailure,
  updateCategoryRequest,
  updateCategorySuccess,
} from "./category/categoryActions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteNotificationFailure, deleteNotificationRequest, deleteNotificationSuccess, fetchNotificationsFailure, fetchNotificationsRequest, fetchNotificationsSuccess, getNotificationStatsFailure, getNotificationStatsRequest, getNotificationStatsSuccess, markAllNotificationsReadFailure, markAllNotificationsReadRequest, markAllNotificationsReadSuccess, markNotificationReadFailure, markNotificationReadRequest, markNotificationReadSuccess } from "./notificationSlice/notificationAction";
import {
  fetchKitchenOrdersRequest,
  fetchKitchenOrdersSuccess,
  fetchKitchenOrdersFailure,
} from "./kitchen/kitchenActions";

const userRole = localStorage.getItem("role");

// helper: convert File/Blob to base64 string
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result); // reader.result is "data:image/png;base64,AAA..."
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
// login
export const login = (email, password, navigate, onError) => {
  return (dispatch) => {
    // loader mate fetchuserLoginRequest
    dispatch(fetchUserLoginRequest());
    axiosInstance
      .post("api/auth/login", { email, password })
      .then((response) => {
        const { token, user } = response.data;

        localStorage.setItem("userData", JSON.stringify(response.data.user));
        localStorage.setItem("token", token);
        dispatch(fetchUserLoginSuccess(response.data));
        toast.success("Successfully logged in!");
        setTimeout(() => {
          // navigate("/");
          if (user.role === "super-admin") {
            navigate("/user");
          } else if (user.role === "admin" || user.role === "branch-admin") {
            navigate("/");
          }
        }, 2000);
      })
      .catch((error) => {
        dispatch(fetchUserLoginFailure(error.message));
        toast.error(
          error.response?.data?.message || "Login failed. Please try again."
        );
      });
  };
};
export const updateUserProfile = (userId, data, navigate) => {
  return (dispatch) => {
    dispatch(updateUserLoginRequest());

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.newPassword);
    formData.append("oldPassword", data.oldPassword);
    if (data.profileImage) {
      formData.append("profileImage", data.profileImage);
    }

    axiosInstance
      .put(`/api/auth/update/${userId}`, formData)
      .then((response) => {
        dispatch(updateUserLoginSuccess(response.data, "userLoginData"));
        toast.success("Successfully updated!");
        // setTimeout(() => {
        //   navigate("/profile"); // or any route you want to redirect to
        // }, 2000);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Something went wrong";

        dispatch(updateUserLoginFailure(errorMessage));
        toast.error(errorMessage);
      });
  };
};

// Other Feature
export const sendOtp = (email, onSuccess, onError) => {
  return async (dispatch) => {
    try {
      const requestBody = { email: email };

      const response = await axiosInstance.post(
        "/api/auth/forgotpassword",
        requestBody
      );
      const { user_id } = response.data;
      toast.success("OTP sent to your email!");
      localStorage.setItem("otpUserId", user_id);

      if (onSuccess) onSuccess(user_id);
    } catch (error) {
      console.error("OTP Error:", error.response?.data);
      const message = error.response?.data?.error || "Failed to send OTP";
      toast.error(message);
      if (onError) onError(message);
    }
  };
};

export const resetPassword = (
  user_id,
  new_password,
  otp,
  navigate,
  onError
) => {
  return async (dispatch) => {
    try {
      const requestBody = {
        user_id: user_id,
        otp: otp,
        new_password: new_password,
      };
      const response = await axiosInstance.post(
        "/api/auth/resetpassword",
        requestBody
      );

      toast.success("Password reset successfully!");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      const message = error.response?.data?.error || "Failed to reset password";
      toast.error(message);
      if (onError) onError(message);
    }
  };
};
export const Register = (data, navigate) => {
  return (dispatch) => {
    dispatch(fetchDataRequest());
    axiosInstance
      .post("api/auth/register", data)
      .then((response) => {
        dispatch(fetchDataSuccess(response.data));
        navigate("/login");
      })
      .catch((error) => {
        dispatch(fetchDataFailure(error.message));
      });
  };
};
// Hotel
export const createHotel = (
  name,
  address,
  phone,
  adminName,
  adminEmail,
  adminPassword,
  userRole,
  onError
) => {
  return (dispatch) => {
    dispatch(createHotelRequest());
    return axiosInstance
      .post("api/hotelBrands", {
        name,
        address,
        phone,
        adminName,
        adminEmail,
        adminPassword,
      })
      .then((response) => {
        dispatch(createHotelSuccess(response.data, "hotelDatas"));
        toast.success("Hotel created successfully");
        if (userRole === "admin") {
          return dispatch(hotelData());
        }
        return dispatch(hotelData());
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        if (onError) {
          onError(errorMsg);
        }
        dispatch(createHotelFailure(error.message));
      });
  };
};
export const hotelData = () => {
  return async (dispatch) => {
    dispatch(fetchHotelRequest());
    try {
      const response = await axiosInstance.get("api/hotelBrands");
      dispatch(fetchHotelSuccess(response.data, "hotelDatas"));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching hotel brands.";

      // toast.error(errorMsg);
      dispatch(fetchHotelFailure(errorMsg));
    }
  };
};

// Dashboard Summary
export const getDashboardSummary = () => {
  return async (dispatch) => {
    dispatch(fetchDashboardSummaryRequest());
    try {
      const response = await axiosInstance.get("api/dashboard/summary");
      dispatch(fetchDashboardSummarySuccess(response.data, "dashboardSummary"));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching dashboard summary.";

      toast.error(errorMsg);
      dispatch(fetchDashboardSummaryFailure(errorMsg));
    }
  };
};

// Profit Loss
// export const getProfitLoss = () => {
//   return async (dispatch) => {
//     dispatch(fetchProfitLossRequest());
//     try {
//       const response = await axiosInstance.get("api/report/profitloss");
//       dispatch(fetchProfitLossSuccess(response.data, "profitLoss"));
//     } catch (error) {
//       const errorMsg =
//         error?.response?.data?.message ||
//         "Something went wrong while fetching profit loss data.";

//       toast.error(errorMsg);
//       dispatch(fetchProfitLossFailure(errorMsg));
//     }
//   };
// };
export const getProfitLoss = (startDate, endDate, limit, page, filter) => {
  return async (dispatch) => {
    dispatch(fetchProfitLossRequest());
    try {
      // Build query parameters
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (limit) params.limit = limit;
      if (page) params.page = page + 1; // if your backend expects 1-based page
      if (filter) params.filter = filter;

      const response = await axiosInstance.get("api/report/profitloss", {
        params,
      });
      dispatch(fetchProfitLossSuccess(response.data, "profitLoss"));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching profit loss data.";

      toast.error(errorMsg);
      dispatch(fetchProfitLossFailure(errorMsg));
    }
  };
};

// HOTEL
export const updateHotelBrand = (hotelTableData, onError) => {
  return (dispatch) => {
    dispatch(updateHotelRequest());
    axiosInstance
      .patch(
        `api/hotelBrands/edithotelBrand/${hotelTableData.id}`,
        hotelTableData
      )
      .then((response) => {
        dispatch(updateHotelSuccess(response.data, "hotelDatas"));
        toast.success(`Hotel Brand  updated successfully`);
        if (userRole === "admin") {
          return dispatch(hotelBrandMyData());
        } else {
          return dispatch(hotelData());
        }
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        if (onError) {
          onError(errorMsg);
        }
        dispatch(updateHotelFailure(error.message));
      });
  };
};
export const deleteHotelBrand = (id, onError) => {
  return (dispatch) => {
    dispatch(deleteHotelRequest());
    axiosInstance
      .delete(`api/hotelBrands/deletehotelBrand/${id}`, id)
      .then((response) => {
        dispatch(deleteHotelSuccess(response.data, "hotelDatas"));
        toast.success(`Hotel Brand deleted successfully`);
        if (userRole === "admin") {
          return dispatch(hotelBrandMyData());
        } else {
          return dispatch(hotelData());
        }
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        if (onError) {
          onError(errorMsg);
        }
        dispatch(deleteHotelFailure(error.message));
      });
  };
};
// CreateBranch
export const createBranch = (
  name,
  address,
  phone,
  branchAdminName,
  branchAdminEmail,
  branchAdminPassword,
  hotelBrand,
  perPage,
  roleBranch = "branch-admin",
  onError
) => {
  return (dispatch) => {
    dispatch(createBranchRequest());
    axiosInstance
      .post("api/branches", {
        name,
        address,
        phone,
        branchAdminName,
        branchAdminEmail,
        branchAdminPassword,
        hotelBrand,
        onError,
        roleBranch,
      })
      .then((response) => {
        dispatch(createBranchSuccess(response.data, "branchDatas"));
        toast.success(`Branch created successfully`);
        return dispatch(branchData(1, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        if (onError) {
          onError(errorMsg);
        }
        dispatch(createBranchFailure(error.message));
      });
  };
};
export const branchData = (page, perPage, searchBranch) => {
  return async (dispatch) => {
    dispatch(fetchBranchRequest());
    try {
      const response = await axiosInstance.get(
        `api/branches?page=${page}&per_page=${perPage}&search=${searchBranch || ""
        }`
      );
      dispatch(fetchBranchSuccess(response?.data, "branchDatas"));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";

      // toast.error(errorMsg);
      dispatch(fetchBranchFailure(errorMsg));
    }
  };
};
export const hotelBrandMyData = () => {
  return (dispatch) => {
    dispatch(fetchHotelRequest());
    axiosInstance
      .get("api/hotelBrands/my")
      .then((response) => {
        dispatch(fetchHotelSuccess(response.data, "hotelDatas"));
      })
      .catch((error) => {
        dispatch(fetchHotelFailure(error.message));
      });
  };
};

// Food
export const createFood = (
  name,
  price,
  type,
  image,
  branchId,
  description,
  category,
  subcategory,
  page,
  rowsPerPage
) => {
  return async (dispatch) => {
    dispatch(createFoodRequest());

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("price", price);
      formData.append("type", type);
      formData.append("branchId", branchId);
      formData.append("description", description);
      formData.append("category", category);
      formData.append("subcategory", subcategory);

      if (image) {
        formData.append("image", image);
      }

      const response = await axiosInstance.post(
        "api/foods/createfood",
        formData
      );

      dispatch(createFoodSuccess(response.data));
      toast.success("Food created successfully");

      // Refresh food list on current page only
      await dispatch(foodList(page, rowsPerPage));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong. Please try again.";

      toast.error(errorMsg);
      dispatch(createFoodFailure(errorMsg));
    }
  };
};
export const foodList = (
  page,
  perPage,
  searchFood,
  filterCategory,
  selectedBranchId,
  onSuccess
) => {
  return async (dispatch) => {
    dispatch(fetchFoodRequest());

    try {
      const response = await axiosInstance.get(
        `api/foods/getallfoods?page=${page}&limit=${perPage}&search=${searchFood || ""
        }&category=${filterCategory || ""}&branchId=${selectedBranchId || ""}`
      );
      dispatch(fetchFoodSuccess(response.data, "foodData"));
      if (onSuccess) onSuccess();
      return response.data;
    } catch (error) {
      let errorMsg = "Something went wrong. Please try again.";

      if (error.response) {
        errorMsg = error.response.data?.message || error.response.statusText;
      } else if (error.request) {
        errorMsg = "Network error. Please check your internet or server.";
      } else {
        errorMsg = error.message;
      }
      console.error("Handled Axios Error:", errorMsg);
      // toast.error(errorMsg);
      dispatch(fetchFoodFailure(errorMsg));
    }
  };
};
// Base64
const base64ToFile = (base64, filename) => {
  const arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
};
// Base64
export const updateFood = (page, perPage, foodData, onError) => {
  return (dispatch) => {
    dispatch(updateFoodRequest());

    const formData = new FormData();
    formData.append("_id", foodData._id);
    if (foodData.name !== undefined) formData.append("name", foodData.name);
    if (foodData.price !== undefined) formData.append("price", foodData.price);
    if (foodData.type !== undefined) formData.append("type", foodData.type);
    if (foodData.isAvailable !== undefined)
      formData.append("isAvailable", foodData.isAvailable);
    if (foodData.category !== undefined)
      formData.append("category", foodData.category);
    if (foodData.subcategory !== undefined)
      formData.append("subcategory", foodData.subcategory);
    if (foodData.description !== undefined)
      formData.append("description", foodData.description);
    if (foodData.quantity !== undefined)
      formData.append("quantity", foodData.quantity);
    if (
      foodData.image &&
      typeof foodData.image === "string" &&
      foodData.image.startsWith("data:image")
    ) {
      const file = base64ToFile(foodData.image, "food-image.png");
      formData.append("image", file);
    } else if (foodData.image instanceof File) {
      formData.append("image", foodData.image);
    }
    return axiosInstance
      .patch(`api/foods/editfood/${foodData._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        dispatch(updateFoodSuccess(response.data, "foodData"));
        toast.success("Food updated successfully");
        return dispatch(foodList(page, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        if (onError) {
          onError(errorMsg);
        }
        dispatch(updateFoodFailure(error.message));
      });
  };
};
export const deleteFood = (_id, page, perPage) => {
  return (dispatch) => {
    dispatch(deleteFoodRequest());
    axiosInstance
      .delete(`api/foods/deletefood/${_id}`, _id)
      .then((response) => {
        dispatch(deleteFoodSuccess(response.data, "foodData"));
        dispatch(foodList(page, perPage));
        toast.success("Food deleted successfully");
      })
      .catch((error) => {
        dispatch(deleteFoodFailure(error.message));
      });
  };
};


export const uploadExcelFood = (file, page = 0, perPage = 25, onError) => {
  return (dispatch) => {
    dispatch(uploadExcelFoodRequest());

    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance
      .post("/api/foods/upload-excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        dispatch(uploadExcelFoodSuccess(response.data));
        dispatch(foodList(page, perPage, "", "", ""));
        return response.data;
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.duplicates?.message ||
          "Failed to upload Excel file";

        if (onError) {
          onError(errorMsg);
        }

        dispatch(uploadExcelFoodFailure(errorMsg));
        return Promise.reject(error);
      });
  };
};


// Table
export const createTable = (
  floor,
  number,
  capacity,
  status,
  waiterName,
  perPage,
  onError
) => {
  return (dispatch) => {
    dispatch(createTableRequest());
    axiosInstance
      .post("api/tables", { floor, number, capacity, status, waiterName })
      .then((response) => {
        dispatch(createTableSuccess(response.data, "tableData"));

        toast.success("Table created successfully");

        dispatch(fetchFloors());
        return dispatch(tableList(1, perPage, undefined, floor));

      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(createTableFailure(error.message));
      });
  };
};
export const tableList = (page, perPage, searchTable, floor) => {
  return (dispatch) => {
    dispatch(fetchTableRequest());

    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (perPage) params.append("per_page", perPage);
    if (searchTable) params.append("search", searchTable);
    if (floor !== undefined && floor !== null && !isNaN(floor)) {
      params.append("floor", floor);
    }

    return axiosInstance
      .get(`api/tables?${params}`)
      .then((response) => {
        dispatch(fetchTableSuccess(response.data, "tableData"));
        return response.data;
      })
      .catch((error) => {
        // if (error.response?.data?.message) {
        //   toast.error(error.response.data.message);
        // } else {
        //   toast.error("Something went wrong. Please try again.");
        // }

        dispatch(fetchTableFailure(error.message));
      });
  };
};
export const fetchFloors = () => {
  return (dispatch) => {
    axiosInstance
      .get("/api/tables/floors")
      .then((res) => {
        dispatch(fetchFloorsSuccess(res.data));
      })
      .catch((err) => {
        console.error("Failed to fetch floors", err);
      });
  };
};
export const updateTable = (tableData, page, perPage, onError) => {
  return (dispatch) => {
    dispatch(updateTableRequest());
    const payload = {
      id: tableData.id,
      number: tableData.number,
      capacity: tableData.capacity,
      floor: tableData.floor,
      status: tableData.status,
      ...(tableData.status === "Occupied" &&
        tableData.orderId && { orderId: tableData.orderId }),
    };
    if (tableData.waiterName) {
      payload.waiterName = tableData.waiterName;
    }
    axiosInstance
      .patch(`api/tables/${tableData._id}`, payload)
      .then((response) => {
        dispatch(updateTableSuccess(response.data, "tableData"));
        toast.success("Table updated successfully");
        return dispatch(tableList(page, perPage, undefined, tableData.floor));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(updateTableFailure(error.message));
      });
  };
};
export const deleteTable = (id, page, perPage, floor = 0) => {
  return (dispatch) => {
    dispatch(deleteTableRequest());
    axiosInstance
      .delete(`api/tables/${id}`, id)
      .then((response) => {
        dispatch(deleteTableSuccess(response.data, "tableData"));
        toast.success("Table deleted successfully");

        return dispatch(tableList(page, perPage, undefined, 1));
      })
      .catch((error) => {
        dispatch(deleteTableFailure(error.message));
      });
  };
};
export const reserveTable = (
  floor,
  number,
  customerName,
  customerPhone,
  reservationDate,
  reservationTime,
  durationValue,
  durationUnit,
  specialRequests = "",
  timeZone = "Asia/Kolkata",
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    try {
      dispatch(fetchTableRequest());

      const response = await axiosInstance.post("/api/tables/reserve", {
        floor,
        number,
        customerName,
        customerPhone,
        reservationDate,
        reservationTime,
        durationValue,
        specialRequests,
        timeZone,
        durationUnit,
      });

      dispatch(fetchTableSuccess(response.data, "reservationData"));
      await dispatch(tableList(1, 5, undefined, floor));

      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Reservation failed.";
      if (onError) onError(errorMsg);
      dispatch(fetchTableFailure(error.message));
    }
  };
};
export const cancelReservation = (
  tableId,
  onSuccess,
  onError,
  perPage,
  floor = 0
) => {
  return (dispatch) => {
    dispatch(fetchTableRequest());
    axiosInstance
      .post(`/api/tables/cancle/${tableId}`)
      .then((response) => {
        if (onSuccess) onSuccess("Table Reservation cancelled successfully");
        return dispatch(tableList(1, perPage || 5, undefined, 0));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error ||
          "Cancellation failed. Please try again.";
        if (onError) onError(errorMsg);

        dispatch(fetchTableFailure(error.message));
      });
  };
};
export const mergeTables = (
  mainTableId,
  mergeTableIds,
  perPage,
  floor = 0,
  onError
) => {
  return (dispatch) => {
    dispatch(fetchTableRequest());

    axiosInstance
      .post("/api/tables/merge", { mainTableId, mergeTableIds })
      .then((response) => {
        dispatch(fetchTableSuccess(response.data.mainTable, "mergedTable"));

        toast.success("Tables merged successfully");

        return dispatch(tableList(1, 5, undefined, floor));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error || "Merge failed. Please try again.";
        onError(errorMsg);
        dispatch(fetchTableFailure(errorMsg));
      });
  };
};
export const splitTable = (tableId, perPage, onError) => {
  return (dispatch) => {
    dispatch(fetchTableRequest());

    axiosInstance
      .post(`/api/tables/split/${tableId}`)
      .then((response) => {
        toast.success("Table split successfully");

        return dispatch(tableList(1, perPage, undefined, 0));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error || "Split failed. Please try again.";
        onError(errorMsg);
        dispatch(fetchTableFailure(errorMsg));
      });
  };
};

// ORDER
export const createOrders = (
  floor,
  tables,
  totalPrice,
  paymentMethod,
  status,
  customerName,
  number,
  foods,
  orderType,
  deliveryAddress,
  perPage,
  onError
) => {
  return (dispatch) => {
    dispatch(createOrderRequest());

    const requestBody = {
      floor,
      tables,
      totalPrice,
      // paymentMethod,
      status,
      customerName,
      number,
      foods,
      orderType,
      deliveryAddress: orderType === "Delivery" ? deliveryAddress : string,
    };

    if (status === "Completed") {
      requestBody.paymentMethod = paymentMethod;
    }

    axiosInstance
      .post("api/orders/createorder", requestBody)
      .then((response) => {
        dispatch(createOrderSuccess(response.data, "orderData"));
        toast.success("Order created successfully");

        dispatch(orderList(1, perPage, "", "", "", null, floor));
        if (onError) onError(null);
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          toast.error(error.response.data.message);
        }

        dispatch(createOrderFailure(error.message));

        // const errorMsg =
        //   error.response?.data?.error ||
        //   "Something went wrong. Please try again.";
        // dispatch(createOrderFailure(errorMsg));
        // if (onError) onError(errorMsg);
      });
  };
};
export const orderList = (
  page,
  perPage,
  searchOrder,
  filterStatus,
  selectedBranchId,
  onSuccess,
   floor
) => {
  return async (dispatch) => {
    dispatch(fetchOrderRequest());

    const url =
      !page && !perPage
        ? `api/orders/getallorders`
        : `api/orders/getallorders?page=${page}&per_page=${perPage}&search=${searchOrder || ""
        }&status=${filterStatus || ""}&branchOrder=${selectedBranchId || ""}`;

    try {
      const response = await axiosInstance.get(url);
      dispatch(fetchOrderSuccess(response.data, "orderData"));
      dispatch(fetchNotifications());
     dispatch(tableList(page, perPage, undefined, floor));
      dispatch(fetchFloors());
      if (onSuccess) onSuccess();
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
      // else {
      //   toast.error("Something went wrong. Please try again later.");
      // }

      dispatch(fetchOrderFailure(error.message));
    }
  };
};
export const getOrder = (_id, page, perPage) => {
  return async (dispatch) => {
    dispatch(fetchOrderRequest());

    try {
      const response = await axiosInstance.get(`api/orders/getorder/${_id}`);
      dispatch(fetchOrderSuccess(response.data, "orderData"));

dispatch(orderList(page, perPage, "", "", "", null, null));
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
      dispatch(fetchOrderFailure(error.message));

      // const errorMsg =
      //   error?.response?.data?.message ||
      //   error?.message ||
      //   "Something went wrong while fetching order.";

      // toast.error(errorMsg);
      // dispatch(fetchOrderFailure(errorMsg));
    }
  };
};
export const updateOrder = (page, perPage,floor, filterName,updateData,  onError) => {


  return (dispatch) => {
    dispatch(updateOrderRequest());
    axiosInstance
      .patch(`api/orders/editorder/${updateData.id}`, updateData)
      .then((response) => {
        dispatch(updateOrderSuccess(response.data, "orderData"));
        toast.success("Order updated successfully");
        dispatch(orderList(1, perPage, "", "", "", null, floor));
        // dispatch(tableList(1, 5, undefined, 0));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(updateOrderFailure(error.message));
      });
  };
};
export const deleteOrder = (id, page, perPage, filterName, onError) => {
  return (dispatch) => {
    dispatch(deleteOrderRequest());
    axiosInstance
      .delete(`api/orders/deleteorder/${id}`)
      .then((response) => {
        dispatch(deleteOrderSuccess(response.data, "orderData"));
        toast.success("Order deleted successfully");
        return dispatch(orderList(page, perPage, filterName));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data || "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(deleteOrderFailure(error.message));
      });
  };
};
// BRANCH
export const updateBranch = (page, perPage, branchDatalist, onError) => {
  return (dispatch) => {
    dispatch(updateBranchRequest());
    return axiosInstance
      .patch(`api/branches/editbranch/${branchDatalist.id}`, branchDatalist)
      .then((response) => {
        dispatch(updateBranchSuccess(response?.data, "branchDatas"));
        toast.success(`Branch updated successfully`);
        dispatch(branchData(page, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(updateBranchFailure(error.message));
      });
  };
};
export const deleteBranch = (id, page, perPage, onError) => {
  return (dispatch) => {
    dispatch(deleteBranchRequest());
    axiosInstance
      .delete(`api/branches/deletebranch/${id}`, id)
      .then((response) => {
        dispatch(deleteBranchSuccess(response?.data, "branchDatas"));
        toast.success(`Branch deleted successfully`);
        return dispatch(branchData(page, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(deleteBranchFailure(error.message));
      });
  };
};

// USER
export const createUser = (userData, onError, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(createUserProfileRequest());
    axiosInstance
      .post("api/users", userData)
      .then((response) => {
        dispatch(createUserProfileSuccess(response.data, "userDatas"));
        toast.success("User created successfully");

        return dispatch(userList(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(createUserProfileFailure(error.message));
      });
  };
};
export const userList = (page, rowsPerPage, search, role) => {
  return async (dispatch) => {
    dispatch(fetchUserProfileDataRequest());
    try {
      const response = await axiosInstance.get(
        `/api/users?page=${page}&per_page=${rowsPerPage}&search=${search || ""
        }&role=${role || ""}`
      );
      dispatch(fetchUserProfileDataSuccess(response.data, "UserDatas"));
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";

      // toast.error(errorMsg);
      dispatch(fetchUserProfileDataFailure(errorMsg));
    }
  };
};
export const updateUser = (userTableData, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(updateUserProfileRequest());
    axiosInstance
      .patch(`api/users/edituser/${userTableData.id}`, userTableData)
      .then((response) => {
        dispatch(updateUserProfileSuccess(response.data, "userDatas"));
        toast.success(`User  updated successfully`);
        return dispatch(userList(page, rowsPerPage));
      })
      .catch((error) => {
        dispatch(updateUserProfileFailure(error.message));
      });
  };
};
export const deleteUser = (id, onError, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(deleteUserProfileRequest());
    axiosInstance
      .delete(`api/users/deleteuser/${id}`, id)
      .then((response) => {
        dispatch(deleteUserProfileSuccess(response.data, "userDatas"));
        toast.success("User deleted successfully");
        return dispatch(userList(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        onError(errorMsg);
        dispatch(deleteUserProfileFailure(error.message));
      });
  };
};

// RAW
export const createRawItem = (
  description, 
  type,
  category,
  purchaseUnit,
  amount,// Accept the entire formData object
  rows,
  rowsPerPage
) => {
  return async (dispatch) => {
    dispatch(createRawItemRequest());

    try {
      const response = await axiosInstance.post("api/raw/rawItem", {
        description,
        type,
        category,
        purchaseUnit,
        amount,
      });

      dispatch(createRawItemSuccess(response.data, "userStockData"));
      toast.success("Stock created successfully");

      await dispatch(getRawItems(rows, rowsPerPage));
    } catch (error) {
      console.error("API Error:", error.response?.data);
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";

      dispatch(createRawItemFailure(errorMsg));
      throw errorMsg; // Important: throw error so it can be caught
    }
  };
};

export const updateRawItem = (data, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(updateRawItemRequest());

    const itemId = data?.id || data?._id;
    
    const updateData = {
      description: data.description,
      type: data.type,
      category: data.category,
      purchaseUnit: data.purchaseUnit,
      amount: Number(data.amount),
    };

    if (data.category !== 'food') {
      delete updateData.purchaseUnit;
    }

    return axiosInstance
      .patch(`api/raw/rawItem/${itemId}`, updateData)
      .then((response) => {
        dispatch(updateRawItemSuccess(response.data, "userStockData"));
        toast.success("Stock updated successfully");
        return dispatch(getRawItems(page, rowsPerPage));
      })
      .catch((error) => {
        console.error("Update Error:", error.response?.data);
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updateRawItemFailure(errorMsg));
        throw errorMsg; // Important for error handling in components
      });
  };
};
export const getRawItems = (page, rowsPerPage, filter, filterCategory, day, startDate, endDate) => {
  return (dispatch) => {
    dispatch(fetchRawItemsRequest());

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('per_page', rowsPerPage);
    if (filterCategory) params.append('category', filterCategory);
    if (filter) params.append('search', filter);
    if (day) params.append('day', day);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    axiosInstance
      .get(`/api/raw/allRawItems?${params.toString()}`)
      .then((response) => {
        dispatch(fetchRawItemsSuccess(response.data, "userStockData"));
      })
      .catch((error) => {
        dispatch(fetchRawItemsFailure(error.message));
      });
  };
};
export const deleteRawItems = (id, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(deleteRawItemRequest());
    axiosInstance
      .delete(`api/raw/rawItem/${id}`, id)
      .then((response) => {
        dispatch(deleteRawItemSuccess(response.data, "userStockData"));
        toast.success("Stock deleted successfully");
        return dispatch(getRawItems(page, rowsPerPage));
      })
      .catch((error) => {
        dispatch(deleteRawItemFailure(error.message));
      });
  };
};
// other
export const monthlyReportList = (
  page,
  perPage,
  startDate,
  endDate,
  search
) => {
  return async (dispatch) => {
    dispatch(fetchMonthlyReportRequest());

    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (perPage) params.append("perPage", perPage);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (search) params.append("search", search);

    try {
      const response = await axiosInstance.get(
        `api/report/monthly-report?${params.toString()}`
      );

      dispatch(fetchMonthlyReportSuccess(response.data, "monthlyData"));
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to fetch monthly reports";

      dispatch(fetchMonthlyReportFailure(message));
      // toast.error(message);
    }
  };
};
export const fetchAllMonthlyReports = () => {
  return axiosInstance.get("api/report/monthly-report?exportExcel=true", {
    responseType: "blob",
  });
};
export const bestSelling = () => {
  return async (dispatch) => {
    dispatch(fetchReportRequest());

    try {
      const response = await axiosInstance.get(`api/report/bestSelling`);
      dispatch(fetchReportSuccess(response.data));
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";
      dispatch(fetchReportFailure(message));
      // toast.error(message);
      throw error;
    }
  };
};
export const paymentMethods = () => {
  return async (dispatch) => {
    dispatch(fetchReportRequest());

    try {
      const response = await axiosInstance.get(`api/report/paymentMethods`);
      dispatch(fetchReportSuccess(response.data));
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";
      dispatch(fetchReportFailure(message));
      // toast.error(message);
      throw error;
    }
  };
};
export const getInvoices = (startDate, endDate, paymentMethod, page = 1, perPage = 10) => {
  return (dispatch) => {
    dispatch(fetchInvoicesRequest());

    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (paymentMethod) params.append("paymentMethod", paymentMethod);
    params.append("page", page);
    params.append("perPage", perPage);

    axiosInstance
      .get(`/api/invoices/invoices?${params.toString()}`)
      .then((response) => {
        dispatch(fetchInvoicesSuccess(response.data));
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message ||
          "Failed to fetch invoices. Please try again..";
        // toast.error(message);
        dispatch(fetchInvoicesFailure(message));
      });
  };
};
// STOCK
export const createStockConsumed = (
  itemName,
  consumed,
  cost,
  mainstock,
  unit,
  rows,
  rowsPerPage
) => {
  return async (dispatch) => {
    dispatch(createStockconsumptionRequest());

    try {
      const response = await axiosInstance.post(
        "api/stock/create-stock-consumption",
        {
          itemName,
          consumed,
          cost,
          mainstock,
          unit,
        }
      );

      dispatch(createStockconsumptionSuccess(response.data, "reportsData"));
      toast.success("Stock Consumption created successfully");

      await dispatch(getStockConsumption(rows, rowsPerPage));
    } catch (error) {
      console.error("API Error:", error.response?.data);
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";

      dispatch(createStockconsumptionFailure(errorMsg));
    }
  };
};
export const getStockConsumption = (page, rowsPerPage, search, status) => {
  return async (dispatch) => {
    dispatch(fetchStockconsumptionRequest());

    try {
      const response = await axiosInstance.get(
        `/api/stock/get-stock-consumption?page=${page}&per_page=${rowsPerPage}&search=${search || ""
        }&status=${status || ""}`
      );

      dispatch(fetchStockconsumptionSuccess(response.data, "UserDatas"));
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Failed to fetch stock consumption data.";
      dispatch(fetchStockconsumptionFailure(message));
      // toast.error(message);
    }
  };
};
export const updateStockConsumption = (data, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(updateStockconsumptionRequest());

    const itemId = data?.id || data?._id;
    return axiosInstance
      .patch(`api/stock/edit-stock-consumption/${itemId}`, data)
      .then((response) => {
        dispatch(updateStockconsumptionSuccess(response.data, "reportsData"));
        toast.success("Stock Consumption updated successfully");
        return dispatch(getStockConsumption(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updateStockconsumptionFailure(errorMsg));
      });
  };
};
export const deleteStockConsumption = (id, page, rowsPerPage) => {
  return async (dispatch) => {
    dispatch(deleteStockconsumptionRequest());
    try {
      const response = await axiosInstance.delete(
        `api/stock/delete-stock-consumption/${id}`
      );
      dispatch(deleteStockconsumptionSuccess(response.data));
      toast.success("Stock Consumption deleted successfully");
      await dispatch(getStockConsumption(page, rowsPerPage));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      dispatch(deleteStockconsumptionFailure(errorMsg));
    }
  };
};

// Expense
export const createexpenses = (category, amount) => {
  return async (dispatch) => {
    dispatch(createExpenseRequest());

    try {
      const response = await axiosInstance.post("api/expenses/createexpenses", {
        category,
        amount,
      });

      dispatch(createExpenseSuccess(response.data, "expensesData"));
      toast.success("Expenses created successfully");

      await dispatch(getexpenses());
    } catch (error) {
      console.error("API Error:", error.response?.data);
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";

      dispatch(createExpenseFailure(errorMsg));
    }
  };
};
export const getexpenses = () => {
  return async (dispatch) => {
    dispatch(fetchExpensesRequest());
    try {
      const response = await axiosInstance.get(`/api/expenses/getexpenses`);
      dispatch(fetchExpensesSuccess(response.data.data));
      console.log(response.data.data, "data1");

    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again.";
      dispatch(fetchExpensesFailure(message));
    }
  };
};
export const updateexpenses = (data) => {
  return (dispatch) => {
    dispatch(updateExpenseRequest());

    const itemId = data?.id || data?._id;
    return axiosInstance
      .patch(`api/expenses/editexpenses/${itemId}`, data)
      .then((response) => {
        dispatch(updateExpenseSuccess(response.data, "expensesData"));
        toast.success("Expenses updated successfully");
        return dispatch(getexpenses());
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updateExpenseFailure(errorMsg));
      });
  };
};
export const deleteExpenses = (_id) => {
  return (dispatch) => {
    dispatch(deleteExpenseRequest());
    axiosInstance
      .delete(`api/expenses/deleteexpenses/${_id}`, _id)
      .then((response) => {
        dispatch(deleteExpenseSuccess(response.data, "expensesData"));
        toast.success("Expenses deleted successfully");
        return dispatch(getexpenses());
      })
      .catch((error) => {
        dispatch(deleteExpenseFailure(error.message));
      });
  };
};

// SUPPLIER
export const createSupplier = (
  name,
  contactPerson,
  phone,
  email,
  address,
  page,
  rowsPerPage
) => {
  return async (dispatch) => {
    dispatch(createSupplierRequest());

    try {
      const response = await axiosInstance.post(
        "api/supplier/createsuppliers",
        {
          name,
          contactPerson,
          phone,
          email,
          address,
        }
      );

      dispatch(createSupplierSuccess(response.data, "SupplierData"));
      toast.success("supplier created successfully");

      await dispatch(getSupplier(page, rowsPerPage));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(error.response?.data?.message);
      dispatch(createSupplierFailure(errorMsg));
    }
  };
};
export const getSupplier = (page, rowsPerPage, search) => {
  return (dispatch) => {
    dispatch(fetchSupplierequest());

    axiosInstance
      .get(
        `/api/supplier/getsuppliers?page=${page}&per_page=${rowsPerPage}&search=${search || ""
        }`
      )
      .then((response) => {
        dispatch(fetchSupplierSuccess(response.data, "SupplierData"));
      })
      .catch((error) => {
        dispatch(fetchSupplierFailure(error.message));
      });
  };
};
export const updateSupplier = (data, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(updateSupplierRequest());

    const itemId = data?.id || data?._id;
    return axiosInstance
      .patch(`api/supplier/editsuppliers/${itemId}`, data)
      .then((response) => {
        dispatch(updateSupplierSuccess(response.data, "SupplierData"));
        toast.success("Supplier updated successfully");
        return dispatch(getSupplier(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updateSupplierFailure(errorMsg));
      });
  };
};
export const deleteSupplier = (_id, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(deleteSupplierRequest());
    axiosInstance
      .delete(`api/supplier/deletesuppliers/${_id}`, _id)
      .then((response) => {
        dispatch(deleteSupplierSuccess(response.data, "SupplierData"));
        toast.success("Supplier deleted successfully");
        return dispatch(getSupplier(page, rowsPerPage));
      })
      .catch((error) => {
        dispatch(deleteSupplierFailure(error.message));
      });
  };
};

// WAITER
export const createWaiter = (
  name,
  age,
  phone,
  email,
  shift,
  address,
  page,
  rowsPerPage
) => {
  return async (dispatch) => {
    dispatch(createWaiterRequest());

    try {
      const response = await axiosInstance.post("api/waiters/createwaiter", {
        name,
        age,
        phone,
        email,
        shift,
        address,
      });

      dispatch(createWaiterSuccess(response.data, "WaiterData"));
      toast.success("Waiter created successfully");

      await dispatch(getWaiters(page, rowsPerPage));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMsg);
      dispatch(createWaiterFailure(errorMsg));
      throw new Error(errorMsg);
    }
  };
};
export const getWaiters = (page, rowsPerPage, search = "") => {
  return (dispatch) => {
    dispatch(fetchWaitersRequest());

    axiosInstance
      .get(
        `/api/waiters/getwaiters?page=${page}&per_page=${rowsPerPage}&search=${search}`
      )
      .then((response) => {
        dispatch(fetchWaitersSuccess(response.data, "WaiterData"));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        // toast.error(errorMsg);
        dispatch(fetchWaitersFailure(errorMsg));
      });
  };
};
export const updateWaiter = (data, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(updateWaiterRequest());

    const itemId = data?.id || data?._id;

    axiosInstance
      .patch(`api/waiters/editwaiter/${itemId}`, data)
      .then((response) => {
        dispatch(updateWaiterSuccess(response.data, "WaiterData"));
        toast.success("Waiter updated successfully");
        dispatch(getWaiters(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        toast.error(errorMsg);
        dispatch(updateWaiterFailure(errorMsg));
      });
  };
};
export const deleteWaiter = (_id, page, rowsPerPage) => {
  return (dispatch) => {
    dispatch(deleteWaiterRequest());

    axiosInstance
      .delete(`api/waiters/deletewaiter/${_id}`)
      .then((response) => {
        dispatch(deleteWaiterSuccess(response.data, "WaiterData"));
        toast.success("Waiter deleted successfully");
        dispatch(getWaiters(page, rowsPerPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        toast.error(errorMsg);
        dispatch(deleteWaiterFailure(errorMsg));
      });
  };
};

// Restaurant
export const saveRestaurantData = (data, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch(fetchInfoRequest());

    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("phone", data.phone);
      formData.append("address", data.address);
      formData.append("email", data.email);
      formData.append("gstNumber", data.gstNumber);
      formData.append("licenseNumber", data.licenseNumber);

      if (data.logo) {
        formData.append("logo", data.logo);
      }

      const response = await axiosInstance.post(
        "api/info/restaurant-info",
        formData
      );

      dispatch(fetchInfoSuccess(response.data.data, "infoData"));
      toast.success("Restaurant info saved successfully");

      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Something went wrong!";
      dispatch(fetchInfoFailure(errorMsg));
      // toast.error(errorMsg);
      if (onError) onError(errorMsg);
    }
  };
};
export const getRestaurantData = () => {
  return async (dispatch) => {
    dispatch(fetchInfoRequest());

    try {
      const response = await axiosInstance.get("api/info/restaurant-info");
      dispatch(fetchInfoSuccess(response.data, "infoData"));
    } catch (error) {
      const errorMsg =
        error.response?.data?.error ||
        "Something went wrong. Please try again.";
      toast.error(errorMsg);
      dispatch(fetchInfoFailure(errorMsg));
    }
  };
};
export const updateRestaurantData = (id, data, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch(updateInfoRequest());

    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("phone", data.phone);
      formData.append("address", data.address);
      formData.append("email", data.email);
      formData.append("gstNumber", data.gstNumber);
      formData.append("licenseNumber", data.licenseNumber);

      if (data.logo) {
        formData.append("logo", data.logo);
      }

      const response = await axiosInstance.patch(
        `api/info/updateinfo/${id}`,
        formData
      );

      dispatch(updateInfoSuccess(response.data.data, "infoData"));
      toast.success("Restaurant info updated successfully");

      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Update failed. Please try again.";
      dispatch(updateInfoFailure(errorMsg));
      toast.error(errorMsg);
      if (onError) onError(errorMsg);
    }
  };
};

// Tax
export const CreateTax = (
  serviceCharge,
  gstTax,
  vat,
  deliveryCharge,
  packagingCharge
) => {
  return async (dispatch) => {
    dispatch(createTaxRequest());

    try {
      const response = await axiosInstance.post("api/tax/tax-setting", {
        serviceCharge,
        gstTax,
        vat,
        deliveryCharge,
        packagingCharge,
      });

      dispatch(createTaxSuccess(response.data, "TaxData"));
      toast.success("tax created successfully");

      await dispatch(getTax());
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMsg);
      dispatch(createTaxFailure(errorMsg));
    }
  };
};
export const getTax = () => {
  return (dispatch) => {
    dispatch(fetchTaxRequest());

    axiosInstance
      .get("/api/tax/tax-setting")
      .then((response) => {
        dispatch(fetchTaxSuccess(response.data, "TaxData"));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message || "Failed to load tax settings";
        dispatch(fetchTaxFailure(errorMsg));
        // toast.error(errorMsg);
      });
  };
};
export const updateTax = (data) => {
  return (dispatch) => {
    dispatch(updateTaxRequest());

    const itemId = data?.id || data?._id;
    return axiosInstance
      .patch(`api/tax/tax-setting/${itemId}`, data)
      .then((response) => {
        dispatch(updateTaxSuccess(response.data, "TaxData"));
        toast.success("tax updated successfully");
        return dispatch(getTax());
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updateTaxFailure(errorMsg));
      });
  };
};

// Printer
export const CreatePrinter = (
  kitchenPrinter,
  receiptPrinter,
  paperSize,
  printKitchenAutomatically,
  printCustomerReceipts,
  autoPrintOnConfirmation
) => {
  return async (dispatch) => {
    dispatch(fetchPrinterRequest());

    try {
      const response = await axiosInstance.post(
        "api/printer/printer-settings",
        {
          kitchenPrinter,
          receiptPrinter,
          paperSize,
          printKitchenAutomatically,
          printCustomerReceipts,
          autoPrintOnConfirmation,
        }
      );

      dispatch(fetchPrinterSuccess(response.data, "PrinterData"));
      toast.success("printer created successfully");

      await dispatch(getPrinter());
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMsg);
      dispatch(fetchPrinterFailure(errorMsg));
    }
  };
};
export const getPrinter = () => {
  return (dispatch) => {
    dispatch(fetchPrinterRequest());

    axiosInstance
      .get("/api/printer/printer-settings")
      .then((response) => {
        dispatch(fetchPrinterSuccess(response.data, "PrinterData"));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message || "Failed to load printer settings";
        dispatch(fetchPrinterFailure(errorMsg));
        // toast.error(errorMsg);
      });
  };
};
export const updatePrinter = (data) => {
  return (dispatch) => {
    dispatch(updatePrinterRequest());

    const itemId = data?.id || data?._id;
    return axiosInstance
      .patch(`api/printer/printer-settings/${itemId}`, data)
      .then((response) => {
        dispatch(updatePrinterSuccess(response.data, "PrinterData"));
        toast.success("printer updated successfully");
        return dispatch(getPrinter());
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        dispatch(updatePrinterFailure(errorMsg));
      });
  };
};
// Category
export const createCategory = (
  category,
  subcategories = [],
  perPage,
  onError
) => {
  return (dispatch) => {
    dispatch(createCategoryRequest());

    const requestBody = { category, subcategories };

    axiosInstance
      .post("api/categories", requestBody)
      .then((response) => {
        dispatch(createCategorySuccess(response.data, "categoryData"));
        toast.success("Category created successfully");
        if (onError) onError(null);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        dispatch(createCategoryFailure(errorMsg));
        if (onError) onError(errorMsg);
      });
  };
};
export const getCategories = (page, rowsPerPage, search = "") => {
  return async (dispatch) => {
    dispatch(fetchCategoryRequest());
    try {
      const response = await axiosInstance.get(
        `/api/categories?page=${page}&perPage=${rowsPerPage}&search=${search}`
      );
      dispatch(fetchCategorySuccess(response.data, "categoryData"));
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Failed to fetch categories";
      dispatch(fetchCategoryFailure(errorMsg));
    }
  };
};
export const deleteCategory = (id, page, perPage) => {
  return (dispatch) => {
    dispatch(deleteCategoryRequest());
    axiosInstance
      .delete(`api/categories/delete/${id}`)
      .then((response) => {
        dispatch(deleteCategorySuccess(response.data, "categoryData"));
        toast.success("Category deleted successfully");
        return dispatch(getCategories(page, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        dispatch(deleteCategoryFailure(errorMsg));
      });
  };
};
export const updateCategory = (id, updatedData, page, perPage) => {
  return (dispatch) => {
    dispatch(updateCategoryRequest());

    axiosInstance
      .patch(`api/categories/update/${id}`, updatedData)
      .then((response) => {
        dispatch(updateCategorySuccess(response.data, "categoryData"));
        toast.success("Category updated successfully");
        return dispatch(getCategories(page, perPage));
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        dispatch(updateCategoryFailure(errorMsg));
      });
  };
};

// Thunk Actions
export const fetchNotifications = (page = 1, rowsPerPage = 20, search = "", filters = {}) => {
  return async (dispatch) => {
    dispatch(fetchNotificationsRequest());
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: rowsPerPage.toString(),
        ...filters
      });

      if (search) {
        params.append('search', search);
      }

      const response = await axiosInstance.get(`/api/notifications?${params}`);

      // Dispatch success with proper data structure
      dispatch(fetchNotificationsSuccess({
        notifications: response.data.notifications || response.data.data || response.data,
        currentPage: response.data.currentPage || page,
        totalPages: response.data.totalPages || 1,
        totalCount: response.data.totalCount || response.data.notifications?.length || 0,
        unreadCount: response.data.unreadCount || 0
      }));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to fetch notifications";
      dispatch(fetchNotificationsFailure(errorMsg));
    }
  };
};

// Mark Notification as Read Thunk
export const markNotificationAsRead = (notificationId) => {
  return async (dispatch) => {
    dispatch(markNotificationReadRequest());
    try {
      const response = await axiosInstance.patch(`/api/notifications/${notificationId}/read`);
      dispatch(markNotificationReadSuccess({
        notification: response.data.notification || response.data
      }));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to mark notification as read";
      dispatch(markNotificationReadFailure(errorMsg));
    }
  };
};

// Mark All Notifications as Read Thunk
export const markAllNotificationsAsRead = () => {
  return async (dispatch) => {
    dispatch(markAllNotificationsReadRequest());
    try {
      const response = await axiosInstance.patch('/api/notifications//read-all');
      dispatch(markAllNotificationsReadSuccess({
        notifications: response.data.notifications || response.data
      }));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to mark all notifications as read";
      dispatch(markAllNotificationsReadFailure(errorMsg));
    }
  };
};

// Delete Notification Thunk
export const deleteNotification = (notificationId) => {
  return async (dispatch) => {
    dispatch(deleteNotificationRequest());
    try {
      const response = await axiosInstance.delete(`/api/notifications/${notificationId}`);
      dispatch(deleteNotificationSuccess({
        notification: response.data.notification || { _id: notificationId }
      }));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to delete notification";
      dispatch(deleteNotificationFailure(errorMsg));
    }
  };
};

export const getNotificationStats = () => {
  return async (dispatch) => {
    dispatch(getNotificationStatsRequest());
    try {
      const response = await axiosInstance.get('/api/notifications/stats');
      dispatch(getNotificationStatsSuccess(response.data));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to fetch notification stats";
      dispatch(getNotificationStatsFailure(errorMsg));
    }
  };
};


export const fetchKitchenOrders = () => {
  return async (dispatch) => {
    dispatch(fetchKitchenOrdersRequest());
    try {
      const response = await axiosInstance.get('/api/kitchen/getkitchen');
      
      // Transform the API response - show only relevant foods based on order type
      const transformedOrders = response.data.orders.map(order => {
        const orderType = order.status; // "new" or "update"
        
        let foodItems = [];
        
        if (orderType === "new") {
          // For new orders, show only new section foods
          foodItems = (order.foods?.new || []).map(food => ({
            name: food.name,
            quantity: food.quantity,
            section: 'new'
          }));
        } else if (orderType === "update") {
          // For updated orders, show only updated section foods
          foodItems = (order.foods?.updated || []).map(food => ({
            name: food.name,
            quantity: food.quantity,
            section: 'updated'
          }));
        }

        return {
          id: order._id,
          orderId: order.orderId,
          customerName: order.customerName,
          type: orderType,
          time: order.createdAt,
          foodItems: foodItems,
          updatedFields: orderType === 'update' ? ['Food items updated'] : []
        };
      });

      dispatch(fetchKitchenOrdersSuccess(transformedOrders));
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to fetch kitchen orders";
      dispatch(fetchKitchenOrdersFailure(errorMsg));
    }
  };
};